<template>
  <v-app-bar
      app
      absolute
      flat
      height="52"
      color="white"
      class="header"
    >
      <v-app-bar-nav-icon
        color="#0D4092"
        @click="setDrawer"
      />
      <div
        class="ma-3 ml-1"
        style="font-weight: 500; font-family: 'Montserrat', sans-serif;"
        v-if="$route.meta.isInfoDevice"
      >
        {{ displayIdDevice }}
      </div>
      <v-spacer v-if="$route.meta.isInfoDevice"></v-spacer>
      <div
        v-if="roleName !== 'checkpoint-admin'"
        class="header-search-fields"
        :class="{
          'header-search-fields--centered': !$route.meta.isInfoDevice,
          'header-search-fields_device': $route.meta.isInfoDevice,
        }"
      >
        <div
          class="search-phone"
          :class="{'custom-search-phone' : $route.meta.isInfoDevice}"
        >
          <v-text-field
            type="phone"
            outlined
            dense
            hide-details
            @keyup.enter="getInfoClientsDoorphones"
            prepend-inner-icon="mdi-magnify"
            style="border-radius: 16px;"
            :placeholder="placeholder"
            v-model="searchTextField"
            @input="formatPhoneNumber"
            :maxlength="searchTextField.startsWith('+7') ? 16 : null"
          />
        </div>
        <div
          v-if="showCarNumberSearch"
          class="search-car-number"
        >
          <vehicle-number-input
            v-model="carNumberSearchField"
            compact
            hide-details
            placeholder="Гос. номер"
            prepend-inner-icon="mdi-car-search"
            :loading="carNumberSearchLoading"
            clearable
            style="border-radius: 16px;"
            @enter="getCarNumberSearch"
          />
        </div>
      </div>
      <v-dialog
        v-model="dialogInfoSearch"
        hide-overlay
        max-width="1200"
        transition="dialog-top-transition"
        content-class="app-header-client-dialog"
      >
        <template v-if="isPhoneNumberFormatted">
          <search-intercom
            :intercoms="intercomsInfo"
            :total-intercoms="totalIntercoms"
            @close="dialogInfoSearch = false"
            :options="options"
            :is-loading="isLoadingIntercom"
            @update:options="updateOptionsDoorphones"
          />
        </template>
        <template v-else>
          <search-client
            :clients="clientsInfo"
            :total-clients="totalClients"
            @close="dialogInfoSearch = false"
            :options="options"
            @update:options="updateOptionsClients"
          />
        </template>
      </v-dialog>
      <v-dialog
        v-model="dialogCarNumberSearch"
        hide-overlay
        max-width="1200"
        transition="dialog-top-transition"
        content-class="app-header-client-dialog"
      >
        <car-number-search-modal
          :result="carNumberSearchResult"
          :error="carNumberSearchError"
          @close="dialogCarNumberSearch = false"
        />
      </v-dialog>
      <v-spacer v-if="$route.meta.isInfoDevice"></v-spacer>
      <div class="header-actions">
        <lk-notifications-bell v-if="showLkNotifications" />
        <v-toolbar-title class="toolbar-title">
        <v-menu bottom left content-class="menu-app-header">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              v-on="on"
              color="#59606A"
              class="pa-1"
              style="width: 100%"
              text
              tile
            >
              <v-icon class="mr-2" v-if="showIntercomInfo">mdi-account</v-icon>
              <span v-if="showIntercomInfo">{{ name }}</span>
              <v-spacer></v-spacer>
              <v-icon v-if="showIntercomInfo">mdi-chevron-down</v-icon>
              <v-icon v-else>mdi-exit-run</v-icon>
            </v-btn>
          </template>
          <v-list class="menu-list">
            <v-list-item class="menu-item">
              <v-list-item-title
                style="border-radius: 16px;"
                class="logout"
                @click="logout"
              >
                Выход
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        </v-toolbar-title>
      </div>
    </v-app-bar>
</template>

<script>
import { store } from '@/main';
import UserService from '@/services/user-service';
import { mapActions, mapGetters } from 'vuex';
import SearchClient from '@/components/app/SearchClient';
import SearchIntercom from '@/components/app/SearchIntercom';
import CarNumberSearchModal from '@/components/app/CarNumberSearchModal';
import VehicleNumberInput from '@/components/VehicleNumberInput';
import ClientApi from '@/services/api/client';
import LkNotificationsBell from '@/components/app/LkNotificationsBell';
import { canViewLkNotifications } from '@/constants/lk-notifications';

export default {
  name: 'AppHeader',
  components: {
    SearchClient,
    SearchIntercom,
    CarNumberSearchModal,
    VehicleNumberInput,
    LkNotificationsBell,
  },
  data () {
    return {
      searchTextField: '',
      clientsInfo: [],
      intercomsInfo: [],
      include: ['abonents.doorphones', 'abonents.keys', 'abonents.apartmentSipSettings'],
      totalClients: 0,
      totalIntercoms: 0,
      options: {
        page: 1,
        itemsPerPage: 5,
      },
      dialogInfoSearch: false,
      isPhoneNumberFormatted: false,
      showIntercomInfo: true,
      isLoading: false,
      isLoadingIntercom: false,
      carNumberSearchField: '',
      carNumberSearchLoading: false,
      carNumberSearchResult: null,
      carNumberSearchError: '',
      dialogCarNumberSearch: false,
    };
  },
  mounted () {
    window.addEventListener('resize', this.checkScreenWidth);
    this.checkScreenWidth();
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkScreenWidth);
  },
  computed: {
    ...mapGetters({
      name: 'name',
      roleName: 'roleName',
    }),
    showLkNotifications () {
      return canViewLkNotifications(this.roleName);
    },
    showCarNumberSearch () {
      return this.roleName === 'admin' && this.showIntercomInfo;
    },
    placeholder () {
      if (this.roleName === 'master') {
        return 'Поиск устройства СКУД';
      }
      if (!this.showIntercomInfo) {
        return 'Клиент или СКУД';
      }
      return 'Поиск клиента или устройства СКУД';
    },
    displayIdDevice () {
      const deviceType = this.$route.meta.typeDevice;
      const deviceName = deviceType === 'I' ? 'Домофон'
        : deviceType === 'B' ? 'Шлагбаум'
          : deviceType === 'G' ? 'Калитка'
            : 'Устройство';

      if (!this.showIntercomInfo) {
        return `№${this.$route.params.id}`;
      } else {
        return `${deviceName} № ${this.$route.params.id}`;
      }
    },
  },
  methods: {
    ...mapActions({
      loadClients: 'Client/loadClients',
      getAllSCUD: 'Doorphone/getAllSCUD',
    }),
    checkScreenWidth () {
      const screenWidth = window.innerWidth;
      this.showIntercomInfo = screenWidth >= 800;
    },
    formatPhoneNumber () {
      this.isPhoneNumberFormatted = false;
      if (/[а-яА-Яa-zA-Z]/.test(this.searchTextField)) {
        this.isPhoneNumberFormatted = true;
        return;
      }
      let digitsOnly = this.searchTextField.replace(/\D/g, '');

      if (digitsOnly.startsWith('7') && this.roleName !== 'master') {
        this.isPhoneNumberFormatted = false;

        if (digitsOnly.length > 11) {
          digitsOnly = digitsOnly.slice(0, 11);
        }

        let formattedNumber = '+7';
        if (digitsOnly.length > 1) {
          formattedNumber += '(' + digitsOnly.slice(1, 4);
        }

        if (digitsOnly.length > 4) {
          formattedNumber += ')' + digitsOnly.slice(4, 7);
        }

        if (digitsOnly.length > 7) {
          formattedNumber += '-' + digitsOnly.slice(7, 9);
        }

        if (digitsOnly.length > 9) {
          formattedNumber += '-' + digitsOnly.slice(9, 11);
        }

        this.searchTextField = formattedNumber.replace(/--/g, '-');

        if (this.searchTextField.endsWith('-')) {
          this.searchTextField = this.searchTextField.slice(0, -1);
        }
      }
    },
    getInfoClientsDoorphones () {
      this.options.page = 1;
      if (!this.searchTextField || this.searchTextField.trim() === '') {
        return;
      }

      const searchValue = this.searchTextField.trim();
      if (/[а-яА-Яa-zA-Z]/.test(searchValue)) {
        if (searchValue.length < 4) {
          this.$flash_danger('Введите минимум четыре символа для поиска устройства.');
          return;
        }
        this.loadDevices();
      } else {
        const phoneNumberToSend = searchValue.replace(/\D/g, '');

        if (phoneNumberToSend.length < 6) {
          this.$flash_danger('Введите минимум шесть цифр для поиска клиента.');
          return;
        }

        this.filters = {
          ...(phoneNumberToSend && { telephone_v2: phoneNumberToSend }),
        };
        this.getClients();
      }
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    loadDevices () {
      if (this.isLoading) return;

      this.isLoading = true;
      const filter = { address: this.searchTextField };

      this.getAllSCUD({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: filter,
      })
        .then((response) => {
          this.intercomsInfo = response.data;
          this.totalIntercoms = response.total;
          if (!this.intercomsInfo[0]) {
            this.$flash_danger('Устройство не найдено, проверьте адрес.');
          } else {
            this.dialogInfoSearch = true;
          }
        })
        .catch((error) => {
          console.error(error);
          this.$sentry_exception(error);
          this.$flash_warning('Ошибка при загрузке устройства.');
        })
        .finally(() => {
          this.isLoading = false;
          this.isLoadingIntercom = false;
        });
    },
    updateOptionsDoorphones (newOptions) {
      this.isLoadingIntercom = true;
      this.options = newOptions;
      this.updateSort();
      this.loadDevices();
    },
    updateOptionsClients (newOptions) {
      this.options = newOptions;
      this.updateSort();
      this.getClients();
    },
    getClients () {
      this.loadClients({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: this.filters,
        include: this.include,
        sort: this.sort = ['-id'],
      })
        .then((data) => {
          this.clientsInfo = data.data;
          if (!this.clientsInfo[0]) {
            this.$flash_danger('Клиент не найден, проверьте номер телефона.');
          } else {
            this.dialogInfoSearch = true;
          }
          this.totalClients = data.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке клиентов');
        });
    },
    getCarNumberSearch () {
      const value = (this.carNumberSearchField || '').trim().replace(/\s+/g, '');
      if (!value || value.length < 4) {
        this.$flash_danger('Введите минимум 4 символа гос. номера.');
        return;
      }
      if (this.carNumberSearchLoading) return;
      this.carNumberSearchLoading = true;
      this.carNumberSearchError = '';
      this.carNumberSearchResult = null;
      ClientApi.getCarNumberSearch(value)
        .then((response) => {
          const data = response.data;
          if (data && data.status && data.summary !== undefined) {
            this.carNumberSearchResult = data;
            this.dialogCarNumberSearch = true;
          } else {
            this.carNumberSearchError = 'По гос. номеру ничего не найдено.';
            this.dialogCarNumberSearch = true;
          }
        })
        .catch((err) => {
          this.carNumberSearchError = err?.response?.data?.message || 'Ошибка при поиске по гос. номеру.';
          this.dialogCarNumberSearch = true;
          this.$sentry_exception && this.$sentry_exception(err);
        })
        .finally(() => {
          this.carNumberSearchLoading = false;
        });
    },
    setDrawer () {
      store.commit('setDrawer', !store.state.drawer);
    },
    logout () {
      UserService.instance.logout({ sso: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.v {

  &-app-bar {

    &.header {

      &:before {
        position: absolute;
        content: '';
        top: calc(100% - 1px);
        left: 0;
        width: 100%;
        border-bottom: 1px solid #E2E4E7;
      }
    }
  }

  &-toolbar-title {

    span {
      color: #59606A;
    }
  }

  &-btn {

    span {
      font-size: 16px;
      line-height: 1;
      color: #59606A;
      text-transform: none;
    }
  }
}

.logout {
  cursor: pointer;
}
.test {
  border-radius: 16px;
}
.logout:hover {
  text-decoration: underline;
  cursor: pointer;
}

.menu-list {
  margin-top: 25px;
  z-index: 9999;
}
.notification-bell {
  transform: rotate(35deg)
}
.header::v-deep .v-toolbar__content {
  position: relative;
}
.header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
  z-index: 2;
}
.header-search-fields {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 8px;
}
.header-search-fields--centered {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  flex: 0 0 auto;
  z-index: 1;
  max-width: calc(100% - 300px);
  pointer-events: none;
}
.header-search-fields--centered > * {
  pointer-events: auto;
}
.search-phone {
  flex: 0 0 auto;
  width: 400px;
  border: none;
  outline: none;
}
.search-car-number {
  flex: 0 0 auto;
  min-width: 160px;
  max-width: 230px;
}
.search-car-number::v-deep .vehicle-number-input__field .v-input__slot fieldset {
  border-radius: 16px;
}
.header-search-fields_device .search-phone {
  margin-right: 10%;
}
.custom-search-phone {
  margin-right: 10%;
}

#my-unique-dialog .v-dialog__content {
  align-items: flex-start; /* Новый стиль для align-items */
}
@media screen and (max-width: 800px) {
  .header-search-fields--centered {
    position: static;
    left: auto;
    transform: none;
    flex: 1 1 auto;
    max-width: calc(100vw - 148px);
    pointer-events: auto;
  }
  .header-search-fields {
    gap: 6px;
  }
  .header-search-fields_device {
    max-width: calc(100vw - 200px);
  }
  .header-search-fields_device .search-phone,
  .custom-search-phone {
    margin-right: 0;
  }
  .search-phone {
    flex: 1 1 auto;
    width: auto;
    min-width: 0;
  }
  .toolbar-title {
    overflow: visible !important;
  }
}
.intercom-id {
  margin: 10px;
}
</style>
